import * as React from 'react';
import Typography from '@mui/material/Typography';
import './PopupContent.component.scss';


export type PopupContentProps = {
  element: JSX.Element;
  contentElement: JSX.Element;
};

const PopupContent = ({
  element,
  contentElement
}: PopupContentProps) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div className="popup-content">
      <div 
        className="popup-content__container"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        {element}
      </div>
      <div 
        className={`popup-content__item ${open ? 'open' : ''}`}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        >
        {contentElement}
      </div>
    </div>
  );
};

export default PopupContent;
